import React, { Component } from 'react';
import { Parallax } from 'react-skrollr';
import PropTypes from 'prop-types';

export default class GradientPage extends Component {
  static propTypes = {
    image: PropTypes.string,
    themeWhite: PropTypes.bool
  };
  static defaultProps = {
    image: 'https://lagunaproperty.com/images/03-sanctuary-club_63.jpg',
    themeWhite: false
  };
  render() {
    const { image, children, themeWhite } = this.props;
    return (
      <div className="gradient-page-component">
        <div className="parallax-container">
          <Parallax
            data={{
              'data-86-bottom-top': 'transform: translateY(-100px); filter: blur(300px) saturate(2);',
              'data-250-top': 'transform: translateY(0px); filter: blur(0px) saturate(1);'
            }}
          >
          <div className="container-img-bg">
            <div className="img-bg"style={{ backgroundImage: `url(${image})`}} />
          </div>
          </Parallax>
        </div>
        <div className={`bg-right ${themeWhite ? 'theme-white': ''}`}>
          <div className="text">{children}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GradientPage.js